import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PolicyModal } from '../components/SettingsModal';

// Página pública usada pela landing page. O conteúdo vem do mesmo componente
// exibido dentro das configurações para evitar versões diferentes dos Termos.
export default function Terms() {
  const navigate = useNavigate();
  return (
    <main className="min-h-screen bg-[#0d0916]">
      <PolicyModal type="terms" onClose={() => navigate('/login')} />
    </main>
  );
}
